import LogoGlobal from '@/assets/icons/LogoGlobal';
import { useSidebar } from '@/components/ui/sidebar';
import { Menu } from 'lucide-react';

export default function CustomTrigger() {
  const { toggleSidebar } = useSidebar();
  return (
    <div onClick={toggleSidebar}>
      <div className='h-10 lg:hidden w-20 p-2 flex items-center justify-between bg-elevated rounded-md'>
        <Menu />
        <LogoGlobal className='w-7 h-7' />
      </div>
    </div>
  );
}
